import { change } from 'redux-form';
import { FORM_NAME } from '../Form';

export default (estimateOptionalIds) => async (dispatch) => {

  dispatch(change(FORM_NAME, 'estimate_optional_ids', estimateOptionalIds))
  
}